<template>
  <model-table
    :data="items"
    :noItemLabel="$t('compCarbonFormsPurchasesTable.no-purchase')"
    :module="module"
    :disabled="isSubmitted"
    :singleUpdateDisabled="false"
    :bulkOpsDisabled="false"
    :withTags="authStore.isAuthenticated"
    @update="$emit('update')"
    @edit="(item) => $emit('edit', item)"
    @del="(items) => $emit('del', items)"
  >
    <b-table-column
      :label="$t('compCarbonFormsPurchasesTable.label-8')"
      field="module"
      sortable
      centered
      v-slot="props"
    >
      <b-tag
        rounded
        type="is-success"
        v-if="props.row.module == purchasesModule"
        >{{ $t(props.row.module) }}</b-tag
      >
      <b-tag rounded v-else-if="props.row.module">{{
        $t(props.row.module)
      }}</b-tag>
      <b-tag rounded type="is-danger" v-else>
        {{ $t('compCarbonFormsPurchasesTable.label-9') }}
      </b-tag>
    </b-table-column>
    <b-table-column
      :label="$t('compCarbonFormsPurchasesTable.label-4')"
      field="code"
      sortable
      searchable
    >
      <template #searchable="props">
        <b-input
          v-model="props.filters[props.column.field]"
          size="is-small"
          icon="search"
          :placeholder="$t('Filter')"
        ></b-input>
      </template>
      <template v-slot="props">
        {{ props.row.code.toUpperCase() }}
      </template>
    </b-table-column>
    <b-table-column
      :label="$t('compCarbonFormsPurchasesTable.label-5')"
      field="description"
      searchable
      :custom-search="searchDescription"
    >
      <template #searchable="props">
        <b-input
          v-model="props.filters[props.column.field]"
          size="is-small"
          icon="search"
          :placeholder="$t('Filter')"
        ></b-input>
      </template>

      <template v-slot="props">
        <span v-if="$t(props.row.getFactorDescription()).length < 30">
          {{ $t(props.row.getFactorDescription()) }}
        </span>
        <span v-else>
          <b-tooltip
            multilined
            :label="$t(props.row.getFactorDescription())"
            type="is-black"
          >
            {{ $t(props.row.getFactorDescription()) | truncate(30) }}
          </b-tooltip>
        </span>
      </template>
    </b-table-column>

    <b-table-column
      :label="$t('compCarbonFormsPurchasesTable.label-10')"
      field="amortization"
      sortable
      searchable
      :custom-search="searchAmort"
      numeric
    >
      <template #searchable="props">
        <b-select
          v-model="props.filters[props.column.field]"
          size="is-small"
          :placeholder="$t('Filter')"
        >
          <option value="all">
            {{ $t('compCarbonFormsPurchasesTable.select.option1') }}
          </option>
          <option value="amort">
            {{ $t('compCarbonFormsPurchasesTable.select.option2') }}
          </option>
          <option value="nonamort">
            {{ $t('compCarbonFormsPurchasesTable.select.option3') }}
          </option>
        </b-select>
      </template>

      <template v-slot="props">
        <span v-if="props.row.amortization > 1">
          {{ props.row.amortization }}
          {{ $t('compCarbonFormsPurchasesTable.yrs') }}
        </span>
      </template>
    </b-table-column>
    <b-table-column
      :label="$t('compCarbonFormsPurchasesTable.label-11')"
      field="info"
      sortable
      searchable
      :custom-search="searchInfo"
    >
      <template #searchable="props">
        <b-input
          v-model="props.filters[props.column.field]"
          size="is-small"
          icon="search"
          :placeholder="$t('Filter')"
        ></b-input>
      </template>
      <template v-slot="props">
        <span v-if="props.row.info.length < 20">
          {{ props.row.info }}
        </span>
        <span v-else>
          <b-tooltip multilined :label="props.row.info" type="is-black">
            {{ props.row.info | truncate(20) }}
          </b-tooltip>
        </span>
      </template>
    </b-table-column>
    <b-table-column
      :label="$t('compCarbonFormsPurchasesTable.label-6')"
      field="amount"
      sortable
      numeric
      v-slot="props"
    >
      {{ props.row.amount | splitFloat }} €
    </b-table-column>
  </model-table>
</template>

<script>
import Purchase from '@/models/carbon/Purchase.js'
import Modules from '@/models/Modules.js'
import { useGHGIStore } from '@/stores/ghgi.js'
import { useAuthenticationStore } from '@/stores/authentication.js'

export default {
  name: 'Table',
  setup () {
    const ghgiStore = useGHGIStore()
    const authStore = useAuthenticationStore()
    return { ghgiStore, authStore }
  },
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    'model-table': () => import('@/components/carbon/forms/ModelTable.vue')
  },
  data () {
    return {
      showPurchases: 'all'
    }
  },
  computed: {
    module: function () {
      return Modules.PURCHASES
    },
    purchasesModule: function () {
      return Purchase.MODULE_NAME
    },
    isSubmitted: function () {
      return this.ghgiStore.item.isSubmitted
    }
  },
  methods: {
    searchAmort: function (row, filter) {
      if (filter === 'amort') {
        return row.amortization > 1
      } else if (filter === 'nonamort') {
        return row.amortization === 1
      } else {
        return true
      }
    },
    searchDescription: function (row, input) {
      let description = row.getFactorDescription().toLowerCase()
      return description.includes(input)
    },
    searchInfo: function (row, input) {
      let info = row.info.toLowerCase()
      return info.includes(input)
    }
  }
}
</script>
